import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Form } from '@ant-design/compatible';
import VideoUploadModal from '../../../../views/app/common/modal/VideoUploadModal';
import withModal from '../../../../lib/hoc/withModal';
import { appActions } from '../../../../store/modules/app';
import { PRODUCT_ATTACHMENT_TYPE } from '../../../../constants/service/app/productConstants';

class ModalContainer extends Component {
  constructor(props) {
    super(props);

    this.state = {
      url: props.data.url,
      width: props.data.width || 560,
      height: props.data.height || 315,
    };
  }

  /**
   * 영상 업로드하기
   */
  onSubmit = () => {
    const { form, data } = this.props;
    const { url, width, height } = this.state;
    const { addVideo } = data;

    form.validateFieldsAndScroll({ scroll: { offsetBottom: 100 } }, (err) => {
      if (err) return;

      addVideo({
        id: new Date().getTime(),
        type: PRODUCT_ATTACHMENT_TYPE.VIDEO,
        isEdit: true,
        url,
        width,
        height,
      });
      /**
       * 모달 닫기
       */
      this.closeModal();
    });
  };

  /**
   * 모달 닫기
   */
  closeModal = () => {
    const { toggleModal } = this.props;
    toggleModal({ name: 'videoUploadModal', value: false });
  };

  /**
   * 데이터 변경
   */
  setData = (data) => {
    this.setState({
      [data.name]: data.value,
    });
  };

  render() {
    return (
      <VideoUploadModal
        {...this.state}
        {...this.props}
        onSubmit={this.onSubmit}
        setData={this.setData}
        closeModal={this.closeModal}
      />
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isOpen: state.app.videoUploadModal.isOpen,
    data: state.app.videoUploadModal.data,
  };
};

const mapDispatchToProps = {
  toggleModal: appActions.appToggleModal,
};

export default connect(mapStateToProps, mapDispatchToProps)(withModal()(Form.create({})(ModalContainer)));
